<template>
  <div class="wrapper">
    <objekto-logo class="fill-current mb-8 h-20 text-white" />
    <well class="w-full sm:w-136 text-primary">
      <h1 class="font-semibold text-lg mb-3">
        {{ $t('account-not-configured.title') }}
      </h1>
      <p>{{ $t('account-not-configured.info') }}</p>
      <btn class="mt-8 w-full" theme="secondary" @click="logout">
        {{ $t('account-not-configured.logout') }}
      </btn>
      <btn class="mt-4 w-full" theme="primary" @click="showSurveyModal = true">
        {{ $t('account-not-configured.answer-questions') }}
      </btn>
    </well>

    <modal :show="showSurveyModal" @update:show="showSurveyModal = $event">
      <div class="w-full">
        <h1 class="text-2xl mt-8 mb-6 text-center">
          {{ $t('account-not-configured.survey-title') }}
        </h1>

        <ValidationObserver v-slot="{ handleSubmit }">
          <form
            class="px-6 my-8 w-full flex flex-col gap-4"
            @submit.prevent="handleSubmit(submitSurvey)"
          >
            <ValidationProvider v-slot="{ errors }" rules="required">
              <text-input
                v-model="surveyForm.firstQuestion"
                type="textarea"
                :label="$t('account-not-configured.first-question')"
                :placeholder="
                  $t('account-not-configured.first-question-placeholder')
                "
                :error="!!errors[0]"
                :error-message="errors[0]"
                :required="true"
                autosize
                :rows="3"
                class="w-full"
              />
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <text-input
                v-model="surveyForm.secondQuestion"
                type="textarea"
                :label="$t('account-not-configured.second-question')"
                :placeholder="
                  $t('account-not-configured.second-question-placeholder')
                "
                :error="!!errors[0]"
                :error-message="errors[0]"
                :required="true"
                autosize
                :rows="3"
                class="w-full"
              />
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" rules="required">
              <text-input
                v-model="surveyForm.thirdQuestion"
                type="textarea"
                :label="$t('account-not-configured.third-question')"
                :placeholder="
                  $t('account-not-configured.third-question-placeholder')
                "
                :error="!!errors[0]"
                :error-message="errors[0]"
                :required="true"
                autosize
                :rows="3"
                class="w-full"
              />
            </ValidationProvider>
            <div class="text-center">
              <btn
                type="submit"
                class="px-8 py-5 w-50"
                theme="primary"
                :disabled="loading"
                :is-loading="loading"
              >
                {{ $t('account-not-configured.submit-survey') }}
              </btn>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </modal>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import ObjektoLogo from '@/assets/Objekto_Logo.svg';
import Well from '@/components/Well/Well.vue';
import Btn from '@/components/Button/Button';
import Modal from '@/components/Modal/Modal.vue';
import { TextInput } from '@/components/Inputs';
import { useAuthUser } from '@/composables';
import { updateClientUser } from '@/api/requests/users';

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    ObjektoLogo,
    Well,
    Btn,
    Modal,
    TextInput,
  },
  setup() {
    const { authUserId, logout } = useAuthUser();

    return {
      authUserId,
      logout,
    };
  },
  data() {
    return {
      showSurveyModal: true,
      surveyForm: {
        firstQuestion: '',
        secondQuestion: '',
        thirdQuestion: '',
      },
      loading: false,
    };
  },
  created() {
    extend('required', {
      ...required,
      message: this.$t('account-not-configured.field-required'),
    });
  },
  methods: {
    async submitSurvey() {
      if (!this.authUserId) {
        this.$toast.error('User ID not found');
        return;
      }

      this.loading = true;

      try {
        await updateClientUser(this.authUserId, {
          firstQuestion: this.surveyForm.firstQuestion,
          secondQuestion: this.surveyForm.secondQuestion,
          thirdQuestion: this.surveyForm.thirdQuestion,
        });

        this.showSurveyModal = false;
        this.$toast.success(this.$t('account-not-configured.survey-success'));
        this.$toast.info(this.$t('account-not-configured.survey-info'));
      } catch (error) {
        this.$toast.error(this.$t('account-not-configured.survey-error'));
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  @apply p-4 flex flex-col items-center justify-center h-screen  bg-cover;
  background-image: url('../assets/background.png');
}
</style>
